import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.182 11.976c0-3.674 1.674-7.145 4.554-9.416C14.558-1.527 7.061-.624 2.997 4.575-1.075 9.774-.176 17.3 5.002 21.382a11.88 11.88 0 0 0 14.734 0 11.95 11.95 0 0 1-4.554-9.41z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M39.028 11.98c0 6.613-5.34 11.968-11.927 11.968-2.672 0-5.266-.903-7.367-2.558 5.179-4.087 6.078-11.608 2.007-16.807a11.9 11.9 0 0 0-2.007-2.014c5.179-4.087 12.676-3.184 16.741 2.01a12 12 0 0 1 2.548 7.395z",
      opacity: ".7"
    }, null, -1)
  ])))
}
export default { render: render }